import { useStaticQuery, graphql } from "gatsby"

export const useSectionUSPData = () => {
  const data = useStaticQuery(graphql`
    query USPQuery {
      contentfulSectionUsp {
        title
        subtitle
        sectionIllustration {
          gatsbyImageData
        }
        items {
          title
          shortDescription {
            shortDescription
          }
          illustration {
            url
          }
        }
      }
    }
  `)

  return data.contentfulSectionUsp
}
